import React, {useState} from 'react'
import {Box, Collapse, useMultiStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {getGDIHideStyles} from '../../utils/gdi-styles'
import {renderLayoutsSwitch, renderComponentsSwitch} from '../../../utils/contentRenderer'
import {ChevronDownIcon} from '../../../../../components/icons'

const renderArea = (contentArea) => {
    if (!Array.isArray(contentArea) || contentArea.length === 0) return null
    const nodes = contentArea
        .map((item, idx) => {
            const exp = item?.ContentLink?.Expanded
            if (!exp) return null
            return (
                <React.Fragment key={idx}>
                    {renderLayoutsSwitch(exp) || renderComponentsSwitch(exp)}
                </React.Fragment>
            )
        })
        .filter(Boolean)
    return nodes.length > 0 ? nodes : null
}

const GDICollapsibleItemBlock = ({
    VisibleTitle,
    InnerContent,
    OpenByDefault,
    HideBlockOn
}) => {
    const [isOpen, setIsOpen] = useState(!!OpenByDefault)
    const styles = useMultiStyleConfig('GDICollapsibleItemBlock', {})
    const hideStyles = getGDIHideStyles(HideBlockOn)
    if (hideStyles.doNotLoadComponent) return null

    const titleContent = renderArea(VisibleTitle)
    const innerContent = renderArea(InnerContent)

    if (!titleContent && !innerContent) return null

    return (
        <Box
            data-block-type="GDICollapsibleItemBlock"
            sx={hideStyles.sx}
            __css={styles.container}
        >
            <Box
                as="button"
                type="button"
                __css={styles.trigger}
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <Box __css={styles.titleWrapper}>{titleContent}</Box>
                <ChevronDownIcon
                    __css={styles.chevron}
                    transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                />
            </Box>
            <Collapse in={isOpen} animateOpacity>
                <Box __css={styles.panel}>{innerContent}</Box>
            </Collapse>
        </Box>
    )
}

GDICollapsibleItemBlock.displayName = 'GDICollapsibleItemBlock'

GDICollapsibleItemBlock.propTypes = {
    VisibleTitle: PropTypes.arrayOf(PropTypes.object),
    InnerContent: PropTypes.arrayOf(PropTypes.object),
    OpenByDefault: PropTypes.bool,
    HideBlockOn: PropTypes.string,
    GDICollapsibleItemBlockAudienceTargeting: PropTypes.object
}

export default GDICollapsibleItemBlock
